import { baseApi } from "@/shared/api/baseApi";

interface AlterarMeusDadosPayload {
  id: number;
  nome: string;
  telefone: string;
}

interface AlterarMinhaSenhaPayload {
  id: number;
  senhaAtual: string;
  novaSenha: string;
}

export interface IniciarAtivacaoMfaResponse {
  qrCodeUri: string;
}

interface ConfirmarAtivacaoMfaPayload {
  codigo: string;
}

export interface MfaRecoveryCodesResponse {
  recoveryCodes: string[];
}

interface RegenerarRecoveryCodesPayload {
  codigo: string;
}

interface DesativarMfaPayload {
  codigo: string;
}

export const meuPerfilApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    alterarMeusDados: builder.mutation<void, AlterarMeusDadosPayload>({
      query: ({ id, ...body }) => ({
        url: `/api/usuario/${id}/AlterarMeusDados`,
        method: "PUT",
        body,
      }),
    }),
    alterarMinhaSenha: builder.mutation<void, AlterarMinhaSenhaPayload>({
      query: ({ id, ...body }) => ({
        url: `/api/usuario/${id}/AlterarMinhaSenha`,
        method: "PUT",
        body,
      }),
    }),
    iniciarAtivacaoMfa: builder.mutation<IniciarAtivacaoMfaResponse, void>({
      query: () => ({
        url: "/api/usuario/seguranca/mfa/iniciar-ativacao",
        method: "POST",
      }),
    }),
    confirmarAtivacaoMfa: builder.mutation<
      MfaRecoveryCodesResponse,
      ConfirmarAtivacaoMfaPayload
    >({
      query: (body) => ({
        url: "/api/usuario/seguranca/mfa/confirmar-ativacao",
        method: "POST",
        body,
      }),
    }),
    regenerarRecoveryCodes: builder.mutation<
      MfaRecoveryCodesResponse,
      RegenerarRecoveryCodesPayload
    >({
      query: (body) => ({
        url: "/api/usuario/seguranca/mfa/regenerar-recovery-codes",
        method: "POST",
        body,
      }),
    }),
    desativarMfa: builder.mutation<void, DesativarMfaPayload>({
      query: (body) => ({
        url: "/api/usuario/seguranca/mfa/desativar",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useAlterarMeusDadosMutation,
  useAlterarMinhaSenhaMutation,
  useIniciarAtivacaoMfaMutation,
  useConfirmarAtivacaoMfaMutation,
  useRegenerarRecoveryCodesMutation,
  useDesativarMfaMutation,
} = meuPerfilApi;
